/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MitgliedsbeitragInputs */

const de__field_mitgliedsbeitrag = /** @type {(inputs: _Field_MitgliedsbeitragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedsbeitrag in €`)
};

/**

* @param {_Field_MitgliedsbeitragInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_mitgliedsbeitrag = /** @type {((inputs?: _Field_MitgliedsbeitragInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MitgliedsbeitragInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_mitgliedsbeitrag(inputs)
});